import VideoAdsPage from './Page'

export default VideoAdsPage
